<div class="modal-header">
    <span class="modal-title">{{ 'update.confirmation.dialog.title' | translate }}</span>
    <button class="btn btn-sm btn-circle btn-ghost" (click)="onCancel()" aria-label="{{'common.buttons.close' | translate}}">✕</button>
</div>
<div class="modal-body">
    <div [innerHTML]="'update.confirmation.dialog.content' | translate"></div>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-ghost" (click)="onCancel()">
        {{ 'update.confirmation.dialog.cancel' | translate }}
    </button>
    <button type="button" class="btn btn-primary" (click)="onConfirm()">
        <strong>{{ 'update.confirmation.dialog.ok' | translate }}</strong>
    </button>
</div>
